export default {
    confirmLabel: '确定',
    backspaceLabel: '退格',
    cancelKeyboardLabel: '收起键盘',
};



// WEBPACK FOOTER //
// ./components/input-item/locale/zh_CN.tsx